export default {"src":"/_next/static/media/LinkWhite.40d6fca8.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};